var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndcall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1727055127059,
    className: "icon",
    viewBox: "0 0 2867 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 19076,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 559.9609375,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1059.57416989 675.79949558s52.09361007-2.68523764 82.38309057-75.07924421c0 0 8.16312241-144.68060363 131.68405348-158.10679179h312.7764794c123.52093108 13.42618817 131.68405348 158.10679178 131.68405349 158.10679179 30.18207099 72.39400657 82.38309056 75.0792442 82.38309055 75.07924421l271.63863889 66.91612178c105.79836271 26.10050979 109.7725144-216.96720068 109.7725144-216.96720069C2060.09371168 272.4768032 1601.99217161 244.76515084 1430.02955365 243.47623678 1258.06693567 244.76515084 799.96539561 272.58421271 678.16301661 525.74841667c0 0 3.97415169 243.06771048 109.7725144 216.96720069l271.63863888-66.91612179z",
    "p-id": 19077,
    fill: "#d81e06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndcall);
export default __webpack_public_path__ + "static/media/endcall.57cef77c64c8fcf7aea1c1182afbade8.svg";
export { ForwardRef as ReactComponent };